import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-common-popup',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  templateUrl: './common-popup.component.html',
  styleUrls: ['./common-popup.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class CommonPopupComponent {
  constructor(
    public dialogRef: MatDialogRef<CommonPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  close(result?: any) {
    this.dialogRef.close(result);
  }

  get headerTitle(): string {
    return this.data?.title || this.formatTemplateName(this.getTemplateName()) || 'Popup';
  }

  get headerIcon(): string {
    const title = (this.headerTitle || '').toLowerCase();
    if (title.includes('delete') || title.includes('remove') || title.includes('revoke')) {
      return 'fa-solid fa-trash-can text-danger';
    } else if (title.includes('confirm') || title.includes('alert') || title.includes('review')) {
      return 'fa-solid fa-circle-question text-warning';
    } else if (title.includes('task')) {
      return 'fa-solid fa-list-check text-primary';
    } else if (title.includes('leave') || title.includes('holiday')) {
      return 'fa-regular fa-calendar-days text-primary';
    } else if (title.includes('password') || title.includes('lock') || title.includes('reset')) {
      return 'fa-solid fa-key text-primary';
    } else if (title.includes('report') || title.includes('consolidated')) {
      return 'fa-solid fa-chart-column text-primary';
    } else if (title.includes('upload') || title.includes('import') || title.includes('pdf')) {
      return 'fa-solid fa-file-arrow-up text-primary';
    }
    return 'fa-solid fa-layer-group text-primary';
  }

  get headerIconBg(): string {
    const title = (this.headerTitle || '').toLowerCase();
    if (title.includes('delete') || title.includes('remove') || title.includes('revoke')) {
      return 'icon-badge-danger';
    } else if (title.includes('confirm') || title.includes('alert') || title.includes('review')) {
      return 'icon-badge-warning';
    }
    return 'icon-badge-primary';
  }

  private getTemplateName(): string {
    if (this.data?.templateName) {
      return this.data.templateName;
    }

    const template = this.data?.template as any;
    const localNames = template?._declarationTContainer?.localNames;

    if (Array.isArray(localNames) && localNames.length) {
      return localNames[0];
    }

    return '';
  }

  private formatTemplateName(value: string): string {
    return value
      .replace(/Tpl$/, '')
      .replace(/Content$/, '')
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/\b\w/g, (char) => char.toUpperCase())
      .trim();
  }
}
